export default "__VITE_ASSET__BaI73ch5__"